import { useRecoilValue } from 'recoil';
import { useTranslation } from '@zurich/common/hooks';
import { fileUploadSelectorFamily } from '@zurich/common/recoil';
import { useUploadFiles } from './useUploadFiles';
/**
 * The usePostGenericDocuments hook is used to upload generic documents
 *
 * @param id a unique description of the document being uploaded
 * @type Hook
 * @returns a fetch function
 */
export function usePostGenericDocuments(id) {
    const { t } = useTranslation();
    const files = useRecoilValue(fileUploadSelectorFamily(id));
    const handleUpload = useUploadFiles();
    const handleFetch = async ({ key, keyType, docType, docSubType, keys, info, }) => {
        if (!files) {
            throw new Error(t('document.errors.uploadDocument'));
        }
        return handleUpload({
            key,
            docType,
            docSubType,
            info,
            files,
            ...(keyType ? { keyType } : { keys }), // It's an either or
        });
    };
    return handleFetch;
}
